<div class="panel">
    <div class="subheader-search">
        <div class="filter-container">
            <div class="search-default">
                <input #searchInput [placeholder]="'creditLetter.search' | translate" (input)="search(searchInput.value)" />
                <mat-icon (keydown.enter)="search(searchInput.value)" (click)="search(searchInput.value)" fontSet="material-icons-round" matSuffix class="search-icon">search</mat-icon>
            </div>

            <div class="select-wrapper">
                <mat-select [(ngModel)]="filteredStatus" class="select" (selectionChange)="search(searchInput.value)">
                    <mat-option *ngFor="let status of statusList" [value]="status">{{  'creditLetter.statusEnum.' + status | translate }}</mat-option>
                </mat-select>
            </div>
        </div>

        <button [disabled]="loading" (click)="newRequest()" mat-flat-button class="btn default">{{ 'creditLetter.newRequest' | translate }}</button>
    </div>

    <h2 class="bold-primary">{{ 'creditLetter.yourRequests' | translate }}</h2>
    <div *ngIf="dataSource?.data.length === 0" class="hint">{{ 'creditLetter.noRequest' | translate }}</div>

    <div class="table-container" *ngIf="dataSource?.filteredData?.length > 0">
        <div class="scroll-table">
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="number">
                    <th mat-header-cell *matHeaderCellDef>{{ 'creditLetter.request' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <span [ngClass]="element?.currentStatus == 'APPROVED' ? 'green' : element?.currentStatus == 'DENIED' ? 'red' : ''">{{ element?.id }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>{{ 'creditLetter.date' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <span [ngClass]="element?.currentStatus == 'APPROVED' ? 'green' : element?.currentStatus == 'DENIED' ? 'red' : ''">{{ element?.createdAt | date: 'shortDate' }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="currentValue">
                    <th mat-header-cell *matHeaderCellDef>{{ 'creditLetter.currentValue' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <span [ngClass]="element?.currentStatus == 'APPROVED' ? 'green' : element?.currentStatus == 'DENIED' ? 'red' : ''">
                            {{ element?.valueRequested | currency: ('creditLetter.currency' | translate) }}
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>{{ 'creditLetter.status' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <span [ngClass]="element?.currentStatus == 'APPROVED' ? 'green' : element?.currentStatus == 'DENIED' ? 'red' : ''">{{ 'creditLetter.statusEnum.' + element?.currentStatus | translate }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="analyst">
                    <th mat-header-cell *matHeaderCellDef>{{ 'creditLetter.analyst' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <span [ngClass]="element?.currentStatus == 'APPROVED' ? 'green' : element?.currentStatus == 'DENIED' ? 'red' : ''">{{ element?.analist ? element.analist : '-' }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="actionsColumn1icon">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon *ngIf="element.currentStatus == 'STARTED'" (click)="editRequisition(element?.id)" fontSet="material-icons-round" [matTooltip]="'creditLetter.editRequisition' | translate" matTooltipClass="tooltip-primary">edit</mat-icon>
                        <mat-icon (click)="viewLetter(element?.id)" fontSet="material-icons-round" [matTooltip]="'creditLetter.viewLetter' | translate" matTooltipClass="tooltip-primary">visibility</mat-icon>
                    </td>
                </ng-container>
                <tr mat-row [ngClass]="(index%2==1)? 'odd': 'even'"
                    *matRowDef="let row; columns: displayedColumns; let index = index">
                </tr>
                <tr mat-header-row class="odd" *matHeaderRowDef="displayedColumns"></tr>
            </table>
        </div>
    </div>
</div>
<mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
